import { useDataValue } from 'Simple/Data.js'

export default function useDataTransform(props, data) {
  let a = useDataValue({
    viewPath: props.viewPath,
    context: 'address',
  })
  return { ...a.postal_address, association_id: a.id }
}
